export enum MfaErrorCodeType {
  InvalidMfaCode = "mfa_code_invalid",
  CooldownNotReached = "cooldown_not_reached",
}
